const radiobutton = {
  iconCheck: {
    backgroundColor: '{secondary.color}',
    color: '{white}',
  },
  bigbtn: {
    borderColor: '{gray.scale.300}',
    backgroundColor: '{white}',
    borderRadius: '{border.radius.l}',

    labelWrapper: {
      padding: '{spacing.m}',
      fontWeight: '{weights.bold}',
    },
    checked: {
      backgroundColor: '{primary.color}',
      color: '{white}',
      transition: 'all 250ms',
      disabled: {
        backgroundColor: '{grayScale.700}',
        color: '{grayScale.700}',
      },
    },
    controlIndicator: {
      default: {
        backgroundColor: '{white}',
        borderRadius: '{border.radius.full}',
        size: '1.25rem',
        offset: '{spacing.xxs}',
      },
    },
    disabled: {
      backgroundColor: '{white}',
      color: '{gray.scale.500}',
    },
  },
  primary: { // variations
    disabled: {
      color: '{grayScale.500}',
    },
    labelWrapper: {
      lineHeight: '1.5',
      marginLeft: '{spacing.xs}',
    },
    controlIndicator: {
      size: '{sizes.m}',
      margin: '{spacing.xxs} 0',
      transition: 'all 250ms',
      default: { // state
        borderRadius: '{border.radius.full}',
        boxShadow: 'inset 0 0 0 1px {grayScale.300}',
        backgroundColor: '{white}',
        hover: {
          backgroundColor: '{grayScale.300}',
        },
      },
      checked: {
        borderRadius: '{border.radius.full}',
        boxShadow: 'inset 0 0 0 .25em {primary.color}',
        borderColor: '{primary.color}',
        backgroundColor: '{white}',
      },
      disabled: {
        boxShadow: 'inset 0 0 0 100em {grayScale.400}',
      },
    },
  },

};

export default radiobutton;
// # sourceMappingURL=index.mjs.map
